  
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Parent_Permision, v_User } from './model';
import { error } from '../error/error';
import { NgxSpinnerService } from 'ngx-spinner';
import { Common } from '../global/common';
import Swal from 'sweetalert2';
import { RequestData } from '../Model/RequestData';
import { Router } from '@angular/router';
import { SidebarService } from './sidebar.service';
import { MsalService } from '@azure/msal-angular';
import { Claims } from './Claims';
import { v_userprofile } from '../../..//app/models/v_userprofile.model';
import { userInfo } from 'os';
import { Console } from 'console';
import { forEachChild } from 'typescript/lib/tsserverlibrary';
import { UserModel } from '../../../app/models/user.modetl';
declare var jQuery: any;
declare var App: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent  {

  public user: v_User;
  public claims :Claims;
  public Permission: Parent_Permision[];
  public error: error[];
  activeLang: boolean;
  public userdata: UserModel = new UserModel();
  public nombreTercero="";
  public Iata ="";
  constructor(private sidebarService: SidebarService,public http: HttpClient, private SpinnerService: NgxSpinnerService, public globals: Common, private router: Router) {
    console.debug("SidebarComponent");    
    this.validateuser() 
  }


  get isSidebarVisible(): boolean {
    return this.sidebarService.isSidebarVisible;
 }

  ngOnInit() {
    
    setTimeout(()=>{    
      
      // let UserInf = localStorage.getItem("ResponseData");
      // let profileUserInf = JSON.parse(localStorage.getItem("profile"));  
      // if (UserInf != null && profileUserInf != null) {
      //     this.Permission = profileUserInf;          
      //     this.globals.IdUser = this.Permission[0].IdUser;              
      //     (function ($) {
      //       $(document).ready(function () {
      //       App.initNavigations();
      //       });
      //     })(jQuery);
      //     this.SpinnerService.hide();
      //   }
        
      //   else {
      //     Swal.fire({
      //       icon: 'error',
      //       title: 'Error!',
      //       text: 'El usuario no contiene Permisos o Roles asignados;por favor contacte al administrador',
      //     });
      //   }

      },10000)
    
  }

  ngAfterViewInit(): void {
    
  }

  private validateuser() {  
    this.SpinnerService.show(); 
    this.userdata = new UserModel();     
    this.user = JSON.parse(localStorage.getItem("ResponseData"));
    this.claims = JSON.parse(localStorage.getItem("Claims"));
    if (this.user != null) {            
      if (this.claims != null) {        
        this.user.Initial = this.claims.given_name.substring(0, 1).toUpperCase() + this.claims.family_name.substring(0, 1).toUpperCase()
      }
    }
    let UserInf: any;
    var request = JSON.stringify(this.user);
    UserInf = localStorage.getItem("ResponseData");
    let body = new HttpParams();
    body = body.set('ObjectRequest', UserInf);
    const bodyProfile = {
      ObjectRequest: request
    }
    this.http.post<UserModel>(window.location.origin + "/api/User/GetByEmail/",bodyProfile).subscribe((data) => {     
      this.userdata = data;      
      console.log(this.userdata)
      this.SpinnerService.hide();
      let UserInf = localStorage.getItem("ResponseData");
      let profileUserInf = JSON.parse(localStorage.getItem("profile"));  
      if (UserInf != null && profileUserInf != null) {
          this.Permission = profileUserInf;          
          this.globals.IdUser = this.Permission[0].IdUser;              
          (function ($) {
            $(document).ready(function () {
            App.initNavigations();
            });
          })(jQuery);
          this.SpinnerService.hide();
        }
        
        else {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'El usuario no contiene Permisos o Roles asignados;por favor contacte al administrador',
          });
        }
  });
  }

}
